import { Card, Button } from "@heroui/react";
import { ThemedText, Tag } from "@/components/ui";
import { LuContainer, LuPencil } from "react-icons/lu";
import { BarakCard, TambahBarakCard } from ".";

const KandangGroup = ({
    data,
    onEdit,
    onAddBarrack,
    onEditBarrack,
    onStartBatch,
}) => {
    return (
        <Card className="border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
            {/* Header / Kandang Info */}
            <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-start gap-4">
                    <div className="bg-primary-100/50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-400 mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl">
                        <LuContainer size={20} />
                    </div>
                    <div>
                        <div className="flex flex-wrap items-center gap-2">
                            <ThemedText size="lg" className="font-bold">
                                {data.name}
                            </ThemedText>
                            <Tag color="default" variant="flat">
                                {data.barracks?.length || 0} Barak
                            </Tag>
                            {data.staff && (
                                <Tag color="primary" variant="flat">
                                    PIC: {data.staff.name}
                                </Tag>
                            )}
                        </div>
                        <ThemedText
                            size="xs"
                            variant="secondary"
                            className="mt-1"
                        >
                            {data.description || "Tidak ada catatan/deskripsi"}
                        </ThemedText>
                    </div>
                </div>
                <Button
                    size="sm"
                    variant="light"
                    startContent={<LuPencil />}
                    className="hover:text-primary-600 text-zinc-500 dark:text-zinc-400"
                    onPress={onEdit}
                >
                    Edit Kandang
                </Button>
            </div>

            {/* Content Area */}
            <div className="px-5 pb-5">
                <div className="mb-4 flex items-center gap-4">
                    <div className="h-px flex-1 bg-zinc-200 dark:bg-zinc-800" />
                    <ThemedText
                        size="xs"
                        className="font-semibold tracking-wider uppercase"
                        variant="secondary"
                    >
                        BARAK ({data.barracks.length})
                    </ThemedText>
                    <div className="h-px flex-1 bg-zinc-200 dark:bg-zinc-800" />
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    <TambahBarakCard onClick={onAddBarrack} />
                    {data.barracks.map((barak) => (
                        <BarakCard
                            key={barak.id}
                            data={barak}
                            onEdit={() => onEditBarrack(barak)}
                            onStartBatch={() => onStartBatch(barak)}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default KandangGroup;
